import { useState } from 'react';
import type { FormEvent } from 'react';
import { Header } from '../components/layout/Header';
import { useAuth } from '../context/auth';

export function Profile() {
  const { user } = useAuth();
  const [first, setFirst] = useState(user?.name.split(' ')[0] ?? '');
  const [last, setLast] = useState(user?.name.split(' ').slice(1).join(' ') ?? '');
  const [company, setCompany] = useState('Geologix Limited');
  const [work, setWork] = useState('');
  const [home, setHome] = useState('');
  const [mobile, setMobile] = useState('');
  const [mfa, setMfa] = useState(false);
  const [saved, setSaved] = useState(false);

  function onSubmit(e: FormEvent) {
    e.preventDefault();
    setSaved(true);
    window.setTimeout(() => setSaved(false), 2500);
  }

  return (
    <div className="app">
      <Header context="wells" />

      <main className="profilepage">
        <form className="profileform" onSubmit={onSubmit}>
          <h1 className="profile-title">
            <svg viewBox="0 0 20 20" width="19" height="19" aria-hidden="true">
              <circle cx="10" cy="6.4" r="3.4" fill="currentColor" />
              <path d="M3.4 17.2a6.6 6.6 0 0 1 13.2 0Z" fill="currentColor" />
            </svg>
            Edit Profile Settings
          </h1>

          <h2 className="profile-section">Personal information</h2>

          <div className="profilegrid">
            <Field label="Username (email address)" value={user?.email ?? ''} readOnly />
            <Field label="Company Name" required value={company} onChange={setCompany} />
            <Field label="Account Type" value="WellExplorer" readOnly />
            <Field label="Work Phone" value={work} onChange={setWork} />
            <Field label="First Name" required value={first} onChange={setFirst} />
            <Field label="Home Phone" value={home} onChange={setHome} />
            <Field label="Last Name" required value={last} onChange={setLast} />
            <Field label="Mobile Phone" value={mobile} onChange={setMobile} />
          </div>

          <div className="profileactions">
            <div>
              <p className="profile-mandatory">* Mandatory</p>
              <button type="button" className="btn-changepw">
                Change Password <span aria-hidden="true">›</span>
              </button>
            </div>

            <button type="submit" className="btn-saveall">
              Save All
            </button>
          </div>

          {saved && (
            <p className="profile-saved" role="status">
              Profile settings saved.
            </p>
          )}

          <h2 className="profile-section">Multi-factor authentication</h2>
          <label className="profile-mfa">
            <input type="checkbox" checked={mfa} onChange={(e) => setMfa(e.target.checked)} />
            <span>
              Require a six-digit code from an authenticator app when signing in on a new device.
            </span>
          </label>
        </form>
      </main>
    </div>
  );
}

function Field({
  label,
  value,
  onChange,
  readOnly = false,
  required = false,
}: {
  label: string;
  value: string;
  onChange?: (v: string) => void;
  readOnly?: boolean;
  required?: boolean;
}) {
  return (
    <label className="profilefield">
      <span>
        {label} {required && <b aria-hidden="true">*</b>}
      </span>
      <input
        type="text"
        value={value}
        readOnly={readOnly}
        required={required}
        className={readOnly ? 'is-readonly' : undefined}
        onChange={(e) => onChange?.(e.target.value)}
      />
    </label>
  );
}
